import React from 'react';
import { AvatarWithIconProps } from './AvatarWithIconPropsInterface';
import { getStyle } from './getStyle';
import { IPurchaseTransaction, TransactionTypeEnum } from '@/services/types/TransactionData';
import AvatarIcon from '@/components/AvatarIcon';
import cn from '@/utils/cn';
import { getReceiptIcon } from './getReceiptIcon';

export const TransactionIcon = (options: AvatarWithIconProps) => {
  const { transactionStatus, data } = options;
  const outlineStyle = getStyle(transactionStatus);
  const imgSrc =
    data.type === TransactionTypeEnum.Purchase
      ? (data.data as IPurchaseTransaction)?.place?.icon ??
        (data.data as IPurchaseTransaction)?.category?.icon ??
        null
      : null;

  let bottomRightIcon = null;

  if (data.type === TransactionTypeEnum.Purchase && options.showReceiptIndicator) {
    bottomRightIcon = getReceiptIcon(data.data as IPurchaseTransaction);
  }

  const cleanUpDataTitle = () => {
    return data.data.title.includes(':') ? data.data.title.split(':')[1] : data.data.title;
  };

  return (
    <>
      <div className={cn(outlineStyle, options.className)}>
        <div className={cn('h-8 w-8', options.className)}>
          <AvatarIcon
            className={cn('h-8 w-8', options.className)}
            key={`transaction-icon-${data.data.id}`}
            name={cleanUpDataTitle()}
            imgSrc={imgSrc}
          />
        </div>
        {data.type === TransactionTypeEnum.Purchase && bottomRightIcon ? (
          <div className={bottomRightIcon.bottomRightContainerStyle}>
            <div className="relative top-0.5 left-0.5">{bottomRightIcon.icon}</div>
          </div>
        ) : null}
      </div>
    </>
  );
};
